import _WidgetBaseSP from 'more/_WidgetBaseSP';
import lang from 'dojo/_base/lang';
import { compose, mdsWidget } from 'dojo/_base/declare';
import template from './EvServiceEditor.html?raw';
import Edit from '../../../../moreCore/UI/Edit/Edit';
import '../../../../moreCore/UI/Edit/Edit';
import CheckBox from '../../../../moreCore/UI/CheckBox/CheckBox';
import '../../../../moreCore/UI/CheckBox/CheckBox';
import GenericDialog from '../../../../moreCore/UI/GenericDialog/GenericDialog';
import "../../../../moreCore/UI/_StatefulBase/_StatefulBase";
import NumberInput from '../../../../moreCore/UI/NumberInput/NumberInput';
import { VAMtypes } from "../../../_loadingHelpers/VAM";
import { ToasterHelpers } from "../../../../more/Helpers";

class EvServiceEditor extends compose(_WidgetBaseSP) {
    templateString: any = template;

    private entity: VAMtypes.EvServiceBooking = null;
    private originalEntity: VAMtypes.EvServiceBooking = null;

    evServiceEditor_TextEditorContainer: HTMLElement;
    evServiceEditor_PriceEditorContainer: HTMLElement;
    evServiceEditor_NoteInternalTextEditorContainer: HTMLElement;
    evServiceEditorMessageContainer: HTMLElement;

    private oversteeredPriceCheckbox: MdsLax<InstanceType<typeof CheckBox>>;
    private freePriceCheckbox: MdsLax<InstanceType<typeof CheckBox>>;
    private priceTotalPricelistCheckbox: MdsLax<InstanceType<typeof CheckBox>>;

    private numberInput_PriceUnitChange: MdsLax<InstanceType<typeof NumberInput>>;
    private numberInput_PriceUnitPricelist: MdsLax<InstanceType<typeof NumberInput>>;
    private numberInput_PriceTotalPricelist: MdsLax<InstanceType<typeof NumberInput>>;
    private numberInput_ValueAgiodisagioUnit: MdsLax<InstanceType<typeof NumberInput>>;
    private numberInput_ValueAgiodisagioTotal: MdsLax<InstanceType<typeof NumberInput>>;
    private numberInput_Discount: MdsLax<InstanceType<typeof NumberInput>>;
    private numberInput_ValueDiscountUnit: MdsLax<InstanceType<typeof NumberInput>>;
    private numberInput_ValueDiscountTotal: MdsLax<InstanceType<typeof NumberInput>>;
    private numberInput_PriceUnitAfterDisc: MdsLax<InstanceType<typeof NumberInput>>;
    private numberInput_PriceTotalAfterDisc: MdsLax<InstanceType<typeof NumberInput>>;
    private numberInput_VatValue: MdsLax<InstanceType<typeof NumberInput>>;
    private numberInput_PriceTotalInclVat: MdsLax<InstanceType<typeof NumberInput>>;

    private edit_evServiceTxt: MdsLax<InstanceType<typeof Edit>>;
    private edit_evServiceNoteInternalTxt: MdsLax<InstanceType<typeof Edit>>;

    isDirty: boolean = false;

    openEditor(entity: VAMtypes.EvServiceBooking): void {

        if (!entity) {
            this.showErrorMessage("setEditedEntity", "NO ENTITY");
            return;
        }

        this.setEditedEntity(entity);

        let dlg = new GenericDialog();
        dlg.destroyOnClose = true;
        dlg.show(this,
            entity.service_type == 4 ? entity.service_original_description : entity.description,
            null,
            null,
            "saveclose",
            lang.hitch(this, this._onDlgResult, dlg));
        this.disableSaveButton(dlg);
        this.on("checkDirty", lang.hitch(this, this.disableSaveButton, dlg));
    }

    setEditedEntity(entity: VAMtypes.EvServiceBooking): void {

        this.entity = { ...entity };

        switch (entity["service_type"]) {
            case 1: //standard
                this.hideNode(this.evServiceEditor_PriceEditorContainer, false);
                if (/*this.hasModule("EvBooking/ServiceEditWithInternalNote")*/ 1) {

                    this.hideNode(this.evServiceEditor_NoteInternalTextEditorContainer, false);
                    this.edit_evServiceNoteInternalTxt.setValue(entity.ev_service_text_internal, true);
                    this.edit_evServiceNoteInternalTxt.isMandatory = false;
                }
                this.hideNode(this.evServiceEditor_TextEditorContainer, true);

                this.oversteeredPriceCheckbox.setValue(entity["is_oversteered_price"], true);
                this.freePriceCheckbox.setValue(!entity["ref_pricelist"], true);
                this.priceTotalPricelistCheckbox.setValue(entity["is_price_total_pricelist"], true);
                this._onPriceCheckboxInputs();

                this.numberInput_PriceUnitChange.setValue(entity.price_unit_change, true);
                this.numberInput_PriceUnitPricelist.setValue(entity.price_unit_pricelist, true);
                this.numberInput_PriceTotalPricelist.setValue(entity.price_total_pricelist, true);
                this.numberInput_ValueAgiodisagioUnit.setValue(entity.value_agiodisagio_unit, true);
                this.numberInput_ValueAgiodisagioTotal.setValue(entity.value_agiodisagio_total, true);
                this.numberInput_Discount.setValue(entity.discount, true);
                this.numberInput_ValueDiscountUnit.setValue(entity.value_discount_unit), true;
                this.numberInput_ValueDiscountTotal.setValue(entity.value_discount_total, true);
                this.numberInput_PriceUnitAfterDisc.setValue(entity.price_unit_after_disc, true);
                this.numberInput_PriceTotalAfterDisc.setValue(entity.price_total_after_disc, true);
                this.numberInput_VatValue.setValue(entity.VAT_value, true);
                this.numberInput_PriceTotalInclVat.setValue(entity.price_total_incl_VAT, true);
                break;
            case 4: //text

                this.hideNode(this.evServiceEditor_PriceEditorContainer, true);
                this.hideNode(this.evServiceEditor_TextEditorContainer, false);

                this.edit_evServiceTxt.setValue(entity.description, true);
                break;
            default:
        }

        
        this.originalEntity = { ...this.entity };
    }

    private _onDlgResult(dlg: MdsLax<InstanceType<typeof GenericDialog>>, result: number) {

        if (result === 1) {
            this._saveChanges();
        }
    }

    private _saveChanges(): void {
        
        let requestUrl = window.appRoot + "EvBookingEditor/SaveServiceChangesData";

        if (this.entity != null) {

            this.RequestManager.post(
                requestUrl,
                {
                    jsonData: JSON.stringify(this.entity)
                },
                lang.hitch(this, this._onSaveEvServiceChangesDataResponse),
                lang.hitch(this, this._onSaveEvServiceChangesDataError),
                false // sync
            );
        }
    }

    private _onSaveEvServiceChangesDataResponse(response): void {
        this.StandbyStop();

        this.emit("saveChanges_success");
        this.showToast({
            title: this.translations["General_SavingSuccessful"],
            iconClass: ToasterHelpers.ToasterIcons.confirmCheck
        });
        this.destroy();
    }

    private _onSaveEvServiceChangesDataError(err): void {
        this.StandbyStop();

        this.showErrorMessage("SaveEvServiceChanges", err.Message);
        //this.destroy();
    }

    _onChange_evServiceTxt(): void {

        this.entity["description"] = this.edit_evServiceTxt.getValue();
        this._checkDirty();
    }

    _onChange_evServiceNoteInternalTxt(): void {

        this.entity["ev_service_text_internal"] = this.edit_evServiceNoteInternalTxt.getValue();
        this._checkDirty();
    }

    _onPriceCheckboxInputs(): void {

        let bOversteeredPrice = this.oversteeredPriceCheckbox.getValue();
        if (bOversteeredPrice === false) {

            this.freePriceCheckbox.setValue(false, true);
            this.priceTotalPricelistCheckbox.setValue(false, true);
        }

        let bFreePrice = this.freePriceCheckbox.getValue();
        if (bFreePrice === false) {

            this.priceTotalPricelistCheckbox.setValue(false, true);
        }

        let bPriceTotalPricelist = this.priceTotalPricelistCheckbox.getValue();

        if (this.entity !== null) {

            this.entity["is_oversteered_price"] = this.oversteeredPriceCheckbox.getValue();
            this.entity["is_free_price"] = this.freePriceCheckbox.getValue();
            this.entity["is_price_total_pricelist"] = this.priceTotalPricelistCheckbox.getValue();
        }

        this.adjustPricelistEdit(bOversteeredPrice, bFreePrice, bPriceTotalPricelist);
        this._checkDirty();
    }

    private adjustPricelistEdit(bOversteeredPrice: boolean, bFreePrice: boolean, bPriceTotalPricelist: boolean): void {

        this.numberInput_PriceUnitChange.setReadonly(true);
        this.numberInput_PriceUnitPricelist.setReadonly(true);
        this.numberInput_PriceTotalPricelist.setReadonly(true);
        this.numberInput_Discount.setReadonly(true);

        if (bOversteeredPrice) {

            this.numberInput_PriceUnitChange.setReadonly(false);
            this.numberInput_Discount.setReadonly(false);
        }
        if (bFreePrice) {

            this.numberInput_PriceUnitChange.setReadonly(true);
            this.numberInput_PriceUnitPricelist.setReadonly(false);
        }
        if (bPriceTotalPricelist) {

            this.numberInput_PriceTotalPricelist.setReadonly(false);
            this.numberInput_PriceUnitPricelist.setReadonly(true);
        }
    }

    _onChangepriceDataNumberInputs(): void {

        let price_unit_change = this.numberInput_PriceUnitChange.getValue();
        price_unit_change === null ? this.entity.price_unit_change = 0 : this.entity.price_unit_change = price_unit_change;

        let price_unit_pricelist = this.numberInput_PriceUnitPricelist.getValue();
        price_unit_pricelist === null ? this.entity.price_unit_pricelist = 0 : this.entity.price_unit_pricelist = price_unit_pricelist;

        let price_total_pricelist = this.numberInput_PriceTotalPricelist.getValue();
        price_total_pricelist === null ? this.entity.price_total_pricelist = 0 : this.entity.price_total_pricelist = price_total_pricelist;

        let discount = this.numberInput_Discount.getValue();
        discount === null ? this.entity.discount = 0 : this.entity.discount = discount;
        this._checkDirty();
    }

    private _checkDirty(): void {

        if (!this.originalEntity) {
            this.isDirty = false;
            return;
        }

        this.isDirty = JSON.stringify(this.entity) != JSON.stringify(this.originalEntity);

        console.log(/*this.isDirty*/"NEW", JSON.stringify(this.entity), "ORIGINAL", JSON.stringify(this.originalEntity));

        this.emit("checkDirty");
    }

    private disableSaveButton(dlg: MdsLax<InstanceType<typeof GenericDialog>>): void {

        this.UiModder.domClass.toggle(dlg.getButtonByName("save").node, "w3-disabled", !this.isDirty);
    }

    showErrorMessage(where: string, message: string): void {

        alert(`ERROR bei ${where}: ${message}`);
    }

    //----------------------- LC -------------------------start
    postCreate(): void {
        super.postCreate.apply(this, arguments as any);
    }
    startup(): void {
        super.startup.apply(this, arguments as any);
    }
}

export default mdsWidget(EvServiceEditor);